import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createBankValidationSchema = Yup.object().shape({
  bankName: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  bankNumber: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  bankOwner: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});

export const linkAuthorBankValidationSchema = Yup.object().shape({
  bankName: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  bankNumber: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  bankOwner: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  identityNumber: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  issuedDate: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  issuedPlace: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  beneficiaryAddress: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
